import request from '@/utils/request'

// 用户列表
export function getXZRegisterList(params){
  return request({
    url: `/xzregister/${params}`,
    method:'GET'
  })
}


export function getXZModuleList(params){
  return request({
    url: `/xzr_auth/modules/`,
    method:'GET'
  })
}


export function updateRegister(id,data) {
  return request({
      url: `/xzregister/${id}/`,
      method: 'PATCH',
      data
  })
}


// 列表
export function getXZAuthList(params){
  return request({
    url: `/xzr_auth/${params}`,
    method:'GET'
  })
}

// 
export function updateXZAuth(id, data){
  return request({
    url: `/xzr_auth/${id}/`,
    method:'PATCH',
    data
  })
}

// 购买
export function buyXZ(data){
  return request({
    url: `/xzr_auth/buy/`,
    method:'POST',
    data
  })
}

// 续费
export function addXZMonth(id, data){
  return request({
    url: `/xzr_auth/${id}/add_months/`,
    method:'POST',
    data
  })
}

// 续费价格
export function addXZMonthPrice(id, data){
  return request({
    url: `/xzr_auth/${id}/add_months_price/`,
    method:'POST',
    data
  })
}


// 购买价格
export function buyXZPrice(data){
  return request({
    url: `/xzr_auth/buy_price/`,
    method:'POST',
    data
  })
}

// 试用
export function trailXZ(data){
  return request({
    url: '/xzr_auth/trail/',
    method:'POST',
    data
  })
}

// 试用延期
export function trialXZDelay(id){
  return request({
    url: `/xzr_auth/${id}/delay/`,
    method:'GET',
  })
}

// 下载
export function getXZLicense(id){
  return request({
    url: `/xzr_auth/${id}/get_license/`,
    method:'GET',
  })
} 


export function addXZMoudle(id, data){
  return request({
    url: `/xzr_auth/${id}/add_modules/`,
    method:'POST',
    data
  })
}

// 续费价格
export function addXZMoudlePrice(id, data){
  return request({
    url: `/xzr_auth/${id}/add_modules_price/`,
    method:'POST',
    data
  })
}

export function addXZUser(id, data){
  return request({
    url: `/xzr_auth/${id}/add_users/`,
    method:'POST',
    data
  })
}

// 续费价格
export function addXZUserPrice(id, data){
  return request({
    url: `/xzr_auth/${id}/add_users_price/`,
    method:'POST',
    data
  })
}






// WEBPACK FOOTER //
// ./src/api/xzr_auth.js